import React, {Component} from 'react';
import * as firebase from 'firebase';
import RichTextArea from '../rich-text-area/rich-text-area';
import './booth-editor.css';

/** @class RichTextContentData
 * A component to enable editing properties
 * specific to RichTextContents.
 */
export default class RichTextContentData extends Component {
  /** @constructor
    * Creates a new instance of the component
    */
  constructor(props) {
    super(props);
    this.state = props.content;
    this.handleChange = this.handleChange.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }
  /** @function handleChange
    * Applies user changes to the state
    * @param {InputEvent} event - the triggering event
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  handleTextChange(html) {
    this.setState({
      'html': html
    }, () => this.handleBlur());
  }
  /** @function handleBlur
    * Applies the current state to the database
    */
  handleBlur() {
    firebase.database().ref(this.props.dataURL).set(this.state);
  }
  /** @function render
    * Renders the component
    */
  render(){
    return (
      <div className="dialog-content">
        <h3 className="header">Rich Text Content</h3>
        <div className="input-group">
          <label htmlFor="name">Name</label><br/>
          <input type="text"
            name="name"
            value={this.state.name}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            />
        </div>
        <div className="input-group">
          <label htmlFor="columns">Columns</label><br/>
          <input type="number"
            name="columns"
            value={this.state.columns}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            />
        </div>
        <div className="input-group">
          <label htmlFor="published">
            <input type="checkbox"
              name="published"
              checked={this.state.published}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              />&nbsp;
            Published
          </label>
        </div>
        <div className="input-group">
          <label>Rich Text</label>
          <RichTextArea value={this.state.html}
            onChange={this.handleTextChange}/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/booth-editor/rich-text-content-data.js